import { AxiosResponseHeaders } from 'axios';
import { CardResponseDTO } from '../entities/Card';

// TODO: DEPRECATED - DELETE ENTIRE FILE
const cardTermsPDFResponseDTOToCardTermsPDFAdapter = (data: CardResponseDTO, headers?: AxiosResponseHeaders): any => {
  if (!data.body) {
    throw new Error();
  }
  return data.body;
};

export { cardTermsPDFResponseDTOToCardTermsPDFAdapter };
